import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import fs from 'fs';
//import path from 'path';

//const directory = './';
/*


Note this whole idea does not work because filesystem is not available
on the browser client

probably best to do an index file as it would be insecure to load a directory
listing of a swerver from a 

and we would need to decide whether to load the index file from server or client.

Maybe just do the loading based on url parameter bit first and index after


*/
//read the directory
/*
const listOfFiles = () => {
  const ret = [];
  // use readdir method to read the files of the direcoty 
  fs.readdir(directory, (err, files) => {
    const ret = [];
    files.forEach(file => {
      // get the details of the file 
      let fileDetails = fs.lstatSync(path.resolve(directory, file));
      // check if the file is directory 
      if (fileDetails.isDirectory()) {
        console.log('Directory: ' + file);
      } else {
        console.log('File: ' + file);
        ret.push(file);
      }
    });
  });
  return ret;
};
*/

// Read details out of one file.
/*
const fileDetail = (fileName) => {
  let ret = { shareClassID: "", name: "" };
  // read in the file and extract data.
  const detail = JSON.parse(fs.readFileSync(fileName, 'utf8'));
  if (detail && detail.SecId && detail.Name) {
    ret.shareClassID = detail.SecId;
    ret.name = detail.Name;
  };
  return ret;
};
*/

/*
  Read the ID and name of every fund in the JSON files.
  
*/
/*
const ListOfFunds = () => {
  let content = [];
  const listOfFiles = listOfFiles();
  // iterate through the files to get
  for (let i = 0; i < listOfFiles.length; i++) {
    const thisFilename = listOfFiles[i];
    const thisObj = fileDetail(thisFilename);
    content.push(thisObj);
  };
  return (
    <Container>
      <h3>Available Factheets</h3>
      {content.map((thisFactsheet) => {
        <Row>
          <Col><a href={thisFactsheet.shareClassID}>{thisFactsheet.name}</a></Col>
        </Row>
      })}
    </Container>

  );
}; */





/*
const ListOfFunds = ({baseURI}) => {
  return (
    <Container>
      <h3>Factsheets</h3>
      <Row>
        <Col><a href={baseURI + "60052417"}>60052417</a></Col>
        <Col>JPM China D Acc USD</Col>
      </Row>
      <Row>
        <Col><a href={baseURI + "60098653"}>60098653</a></Col>
        <Col>JPM Greater China X Acc USD</Col>
      </Row>
      <Row>
        <Col><a href={baseURI + "60099923"}>60099923</a></Col>
        <Col>JPM China C Acc USD</Col>
      </Row>
      <Row>
        <Col><a href={baseURI + "65034752"}>65034752</a></Col>
        <Col>JPMrgn Taiwan I Acc USD</Col>
      </Row>
    </Container>
  );
};
*/

const ListOfFunds = ({ data }) => {

  const path = window.location.pathname;
  return (
    <Container>
      <h3>Factsheets</h3>
      {data.map((item, index) => (
        <Row key={index}>
          <Col className="tableitem"><a href={ path + "?" + item.id }>{item.id}</a></Col>
          <Col className="tableitem">{item.name}</Col>
        </Row>
      ))}
    </Container>
  );
};

export default ListOfFunds;